<template>
  <b-form class="mt-2">
    <titleSection
      title="Dirección (datos de domicilio particular)"
      icon="MapPinIcon"
    />

    <!-- Poner el domicilio como viene en el INE -->
    <div class="my-1">
      <b-alert
        variant="primary"
        show
      >
        <div class="alert-body text-center">
          <span>Por favor coloca el domicilio <b>registrado en tu INE</b></span>
        </div>
      </b-alert>
    </div>

    <b-row class="mt-1">
      <!-- calle  -->
      <b-col
        md="6"
        lg="6"
      >
        <validation-provider
          #default="{ errors }"
          name="calle"
          :rules="rulerequerido ? 'max:255|required': 'max:255'"
        >
          <b-form-group
            label="Calle"
            label-for="calle"
          >
            <b-form-input
              id="calle"
              v-model="formulario.calle"
              autocomplete="off"
              placeholder="Escriba aquí la calle"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <!-- numero  -->
      <b-col
        md="6"
        lg="3"
      >
        <validation-provider
          #default="{ errors }"
          name="número"
          :rules="formulario.calle || rulerequerido ? 'max:15|required': 'max:15'"
        >
          <b-form-group
            label="Número"
            label-for="numero"
          >
            <b-form-input
              id="numero"
              v-model="formulario.numero"
              autocomplete="off"
              placeholder="Escriba aquí el número"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <!-- interior  -->
      <b-col
        md="6"
        lg="3"
      >
        <validation-provider
          #default="{ errors }"
          name="interior"
          rules="max:25"
        >
          <b-form-group
            label="Interior"
            label-for="interior"
          >
            <b-form-input
              id="interior"
              v-model="formulario.interior"
              autocomplete="off"
              placeholder="Escriba aquí el número interior"
              :state="errors.length > 0 ? false:null"
            />
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <!-- código postal  -->
      <b-col
        md="6"
        lg="4"
      >
        <validation-provider
          #default="{ errors }"
          name="código postal"
          :rules="formulario.calle || rulerequerido ? 'digits:5|required': 'digits:5'"
        >
          <b-form-group
            label="Código postal"
            label-for="cp"
          >
            <b-form-input
              id="cp"
              v-model="formulario.cp"
              :state="errors.length > 0 ? false:null"
              placeholder="Escriba aquí el código postal"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
      <!-- colonia  -->
      <b-col
        md="6"
        lg="8"
      >
        <validation-provider
          #default="{ errors }"
          name="colonia"
          :rules="formulario.calle || rulerequerido ? 'max:200|required': 'max:200'"
        >
          <b-form-group
            label="Colonia*"
            label-for="colonia"
          >
            <b-form-input
              id="colonia"
              v-model="formulario.colonia"
              autocomplete="off"
              placeholder="Escriba aquí la colonia"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <!-- municipio -->
      <b-col
        md="12"
        lg="12"
      >
        <validation-provider
          #default="{ errors }"
          name="municipio"
          :rules="formulario.calle || rulerequerido ? 'required': ''"
        >
          <b-form-group
            label="Municipio*"
            label-for="municipio"
          >
            <v-select
              v-model="formulario.municipio"
              placeholder="Búsque su municipio y seleccionelo"
              label="nombre"
              :filterable="false"
              :options="municipios"
              :clearable="false"
              @search="onSearch"
            >
              <!-- CUANDO NO HAY OPCIONES -->
              <template #no-options>
                Teclea al menos 4 letras de tu municipio y seleccionelo
              </template>
              <!-- COMO SE VEN LAS OPCIONES -->
              <template #option="{ nombre }">
                <span>{{ nombre }}</span>
              </template>                    <!-- COMO SE VE LA OPCIÓN SELECCIONADA -->
              <template #selected-option="{ nombre }">
                <div>
                  <b
                    v-if="nombre!==null"
                    class="text-primary"
                  >{{ nombre }}</b>
                  <div
                    v-if="nombre===null"
                    class="text-danger"
                  >Teclea al menos 4 letras de tu municipio y seleccionelo</div>
                </div>
              </template>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'
import titleSection from '@/views/components/title-section.vue'
import vSelect from 'vue-select'
import { getData } from '@core/utils/http/general'
import { isObject, isEmptyObject } from '@core/utils/utils'

export default {
  components: {
    titleSection,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    vSelect,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    direccionx: {
      type: Object,
      default: () => {},
    },
    rulerequerido: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formulario: {
      get() {
        if (isObject(this.direccionx) && !isEmptyObject(this.direccionx)) return this.direccionx
        return {}
      },
      set(newValue) { this.formulario = newValue },
    },
  },
  setup() {
    const municipios = ref([])
    const onSearch = (search, loading) => {
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS
      loading(true)
      getData({ action: 25, search })
        .then(response => {
          loading(false)
          if (response.status === 200 && response.data.status === 200) {
            municipios.value = response.data.data
            return true
          }
          municipios.value = []
          return false
        })
        .catch(err => {
          loading(false)
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [municipio]',
            variant: 'danger',
          })
        })
      return true
    }
    return {
      required,
      municipios,
      onSearch,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
